import classNames from 'classnames';
import React, { Children, cloneElement, isValidElement, useCallback, useState } from 'react';
import { __DEV__ } from "../../helper/dev.js";
import styles from "./ButtonGroup.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
const resetButtonProps = {
  className: undefined,
  loading: false,
  fullWidth: false
};
export const ButtonGroup = ({
  activeIndex,
  className,
  small,
  secondary,
  disabled,
  onChange,
  children
}) => {
  const [activeButton, setActiveButton] = useState(activeIndex);
  const classes = classNames(styles.buttonGroup, className);
  const handleChange = useCallback(index => {
    if (onChange) {
      onChange(index);
    }
    setActiveButton(index);
  }, [onChange, setActiveButton]);
  if (!children) {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.error(`[Illegal state]: you need to pass child elements. Note: only <Button /> are allowed!`);
    }
    return null;
  }

  // reduce all not allowed elements - only Button-Components are allowed!
  const normalizedChildElements = Children.map(children, (child, index) => {
    if (/*#__PURE__*/isValidElement(child)) {
      const props = {
        ...resetButtonProps,
        secondary,
        disabled,
        small,
        variant: index === activeButton ? '' : 'outlined',
        onClick: () => handleChange(index)
      };
      return /*#__PURE__*/cloneElement(child, props);
    }
    return null;
  })?.filter(Boolean);
  if (normalizedChildElements.length === 0) {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.error(`[Illegal state]: found only invalid children! Only <Button /> are allowed! For more information, read <ButtonGroup /> docs`);
    }
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    role: "group",
    "aria-label": "button group",
    className: classes,
    children: normalizedChildElements
  });
};